import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {SearchService} from '../search.service';

@Component({
    selector: 'app-search',
    templateUrl: './search.component.html',
    styleUrls: ['./search.component.css']
})
export class SearchComponent implements OnInit {
    public searchItems;
    public searchTerm = '';
    public objectKeys = Object.keys;
    constructor(
        private route: ActivatedRoute,
        private searchService: SearchService
    ) {
        this.route.queryParams.subscribe(
            (val) => {
                console.log('got change in search query: ', val);
            });
    }

    ngOnInit() {
        this.searchTerm = this.route.snapshot.paramMap.get('query');
        console.log('search component called with searchTerm: ', this.searchTerm);
        this.searchService.setSearchTerm(this.searchTerm);
        this.searchService.getSubject().subscribe({
            next: (val) => {
                console.log('setting dashboardItems to:', val);
                this.searchItems = val;
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/search/search/search.component.ts